import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { paymentTermLoanMaturityCommissionServicesNotesFileState, SupportingDocumentFile } from "./payment_term-loan_maturity-commission_services-notes-files.state";
import { RootState } from "../../../api/store";
import { SubTypeOption } from "../../../api/gms/group-category/group-category-api-state";

const initialState: paymentTermLoanMaturityCommissionServicesNotesFileState = {
    // payment term
    selectedPaymentTerm: null,
    // loan maturity
    selectedLoanMaturity: null,
    selectedLoanMaturityMonths: null,
    // commission and services
    commissionValue: 0,
    serviceValue: 0,
    // notes
    content: '',
    // supporting files(GMS)
    files: [],
    isDragging: false,
};

const paymentTermLoanMaturityCommissionServicesNotesFilesSlice = createSlice({
    name: "paymentTermLoanMaturityCommissionServicesNotesFilesSlice",
    initialState,
    reducers: {
        // payment term
        setSelectedPaymentTermBox: (state, action: PayloadAction<SubTypeOption | null>) => {
            state.selectedPaymentTerm = action.payload;
        },
        // loan maturity
        setSelectedLoanMaturityBox: (state, action: PayloadAction<SubTypeOption | null>) => {
            state.selectedLoanMaturity = action.payload;
        },
        setUpdateLoanMaturityMonths: (state, action: PayloadAction<number>) => {
            state.selectedLoanMaturityMonths = action.payload;
        },
        resetLoanMaturityType: (state) => {
            state.selectedLoanMaturity = null;
            state.selectedLoanMaturityMonths = null;
        },
        // commission and services
        setCommissionValue: (state, action: PayloadAction<number>) => {
            state.commissionValue = action.payload;
        },
        setServiceValue: (state, action: PayloadAction<number>) => {
            state.serviceValue = action.payload;
        },
        // notes
        setNotesContent: (state, action: PayloadAction<string>) => {
            state.content = action.payload;
        },
        // supporting files(GMS)
        addFiles: (state, action: PayloadAction<File[]>) => {
            const startId = state.files.length > 0
                    ? Math.max(...state.files.map(item => item.id)) + 1
                    : 0;
            const newFiles: SupportingDocumentFile[] = action.payload.map((file, index) => ({
                id: startId + index,
                file,
                fileName: file.name,
                filePath: "",
                type: "new",
                supportingId: null,
            }));

            state.files.push(...newFiles);
        },
        populateSupportingDocuments: (state, action: PayloadAction<{ fileName: string, filePath: string}[] | null>) => {
            state.files = (action.payload ?? []).map((item, index) => ({
                id: index,
                file: null,
                fileName: item.fileName,
                filePath: item.filePath,
                type: "old",
                supportingId: null,
            }));
        },
        removeFile: (state, action: PayloadAction<number>) => {
            state.files = state.files.filter(
                item => item.id !== action.payload
            );
        },
        clearFiles: (state) => {
            state.files = [];
        },
        setDragging: (state, action: PayloadAction<boolean>) => {
            state.isDragging = action.payload;
        },
    },
});

export const { 
    // payment term
    setSelectedPaymentTermBox,
    // loan maturity
    setSelectedLoanMaturityBox,
    setUpdateLoanMaturityMonths,
    resetLoanMaturityType,
    // commission and services
    setCommissionValue,
    setServiceValue,
    // notes
    setNotesContent,
    // supporting files(GMS)
    addFiles,
    removeFile,
    clearFiles,
    setDragging,
    populateSupportingDocuments,
} = paymentTermLoanMaturityCommissionServicesNotesFilesSlice.actions;

// payment term
export const selectPaymentTerm = (state: RootState) => state.paymentTermLoanMaturityCommissionServicesNotesFilesSlice.selectedPaymentTerm;
// loan maturity
export const selectLoanMaturityTypeState = (state: RootState) => state.paymentTermLoanMaturityCommissionServicesNotesFilesSlice.selectedLoanMaturity;
export const selectLoanMaturityMonthsState = (state: RootState) => state.paymentTermLoanMaturityCommissionServicesNotesFilesSlice.selectedLoanMaturityMonths;
// commission and services
export const selectCommissionValueState = (state: RootState) => state.paymentTermLoanMaturityCommissionServicesNotesFilesSlice.commissionValue;
export const selectServiceValueState = (state: RootState) => state.paymentTermLoanMaturityCommissionServicesNotesFilesSlice.serviceValue;
// notes
export const selectNotesState = (state: RootState) => state.paymentTermLoanMaturityCommissionServicesNotesFilesSlice.content 
// supporting files(GMS)
export const selectFiles = (state: RootState) => state.paymentTermLoanMaturityCommissionServicesNotesFilesSlice.files
export const selectIsDragging = (state: RootState) => state.paymentTermLoanMaturityCommissionServicesNotesFilesSlice.isDragging

export default paymentTermLoanMaturityCommissionServicesNotesFilesSlice.reducer;
